// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --primary-white: #fff;
  --primary-black: #000;
  --primary-grey: #73739a;
  --primary-blue: #6d72f6;
  --primary-green: #08ce8a;
  --primary-black2: #1c1c57;
}

.Blog {
  width: 100%;
  padding: 2rem 20px;
  box-sizing: border-box;
}

.Blog-title {
  text-align: center;
  margin-bottom: 4rem;
}

.Blog-title h1 {
  font-size: 38px;
  color: var(--primary-black2);
}

.Blog-title p{
  font-size: 18px;
  color: var(--primary-grey);
}

.Blog-box {
  display: flex;
  align-items: center;
  width: 100%;
  margin: 0 auto;
  max-width: 1200px;
  gap: 100px;
}

.Blog-left {
  width: 50%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.Blog-left-round {
  width: 500px;
  height: 500px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-image: linear-gradient(153deg, #dbdcff, #6d72f6);
}

.Blog-left-round img {
  width: 100%;
  height: 580px;
  max-width: 350px;
  object-fit: contain;
}

.Blog-right {
  width: 50%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.Blog-right-main {
  display: flex;
  flex-direction: column;
}

.Blog-Hidden-box {
  padding: 20px 15px;
  border-radius: 20px;
  border: none;
  background: transparent;
  text-align: left;
  font-size: 26px;
  color: var(--primary-grey);
  font-weight: bolder;
  overflow: hidden;
  height: 70px;
  display: flex;
  flex-direction: column;
  transition: all 0.3s ease;
  cursor: pointer;
}

.Blog-Hidden-box p {
  font-size: 18px;
  font-weight: 400;
  line-height: 30px;
  opacity: 0;
  max-height: 0;
  transition: all 0.3s ease;
}

.Blog-Hidden-box.active {
  height: 120px;
  box-shadow: 0 18px 30px 0 #dfdfdf;
}

.Blog-Hidden-box.active p {
  opacity: 1;
  max-height: 100px;
}

/* Responsive Styles */
@media (max-width: 1024px) {
  .Blog {
    height: auto;
    padding: 20px;
  }

  .Blog-box {
    flex-direction: column-reverse;
    gap: 40px;
  }

  .Blog-left,
  .Blog-right {
    width: 100%;
  }

  .Blog-left-round {
    width: 80%;
    height: auto;
    max-width: 350px;
  }

  .Blog-left-round img {
    height: auto;
    max-width: 100%;
  }

  .Blog-Hidden-box {
    font-size: 30px;
    padding: 20px;
  }

  .Blog-Hidden-box p {
    font-size: 16px;
  }
}

@media (max-width: 768px) {
  .Blog-box {
    gap: 20px;
  }

  .Blog-Hidden-box.active {
    height: 80px;
  }

  .Blog-left-round {
    width: 90%;
    max-width: 300px;
  }

  .Blog-Hidden-box {
    font-size: 24px;
    padding: 15px;
  }

  .Blog-Hidden-box p {
    font-size: 14px;
    line-height: 22px;
  }
}

@media (max-width: 480px) {
  .Blog-left-round {
    width: 100%;
    max-width: 250px;
  }

  .Blog-Hidden-box {
    font-size: 20px;
    padding: 10px;
  }

  .Blog-Hidden-box.active {
    height: 100px;
  }

  .Blog-Hidden-box p {
    font-size: 12px;
    line-height: 18px;
  }
}`, "",{"version":3,"sources":["webpack://./src/Components/Blog/Blog.css"],"names":[],"mappings":"AAAA;EACE,qBAAqB;EACrB,qBAAqB;EACrB,uBAAuB;EACvB,uBAAuB;EACvB,wBAAwB;EACxB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,cAAc;EACd,iBAAiB;EACjB,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,2DAA2D;AAC7D;;AAEA;EACE,WAAW;EACX,aAAa;EACb,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;EACf,0BAA0B;EAC1B,mBAAmB;EACnB,gBAAgB;EAChB,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,UAAU;EACV,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,iCAAiC;AACnC;;AAEA;EACE,UAAU;EACV,iBAAiB;AACnB;;AAEA,sBAAsB;AACtB;EACE;IACE,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,8BAA8B;IAC9B,SAAS;EACX;;EAEA;;IAEE,WAAW;EACb;;EAEA;IACE,UAAU;IACV,YAAY;IACZ,gBAAgB;EAClB;;EAEA;IACE,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,SAAS;EACX;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,UAAU;IACV,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,aAAa;EACf;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;AACF","sourcesContent":[":root {\n  --primary-white: #fff;\n  --primary-black: #000;\n  --primary-grey: #73739a;\n  --primary-blue: #6d72f6;\n  --primary-green: #08ce8a;\n  --primary-black2: #1c1c57;\n}\n\n.Blog {\n  width: 100%;\n  padding: 2rem 20px;\n  box-sizing: border-box;\n}\n\n.Blog-title {\n  text-align: center;\n  margin-bottom: 4rem;\n}\n\n.Blog-title h1 {\n  font-size: 38px;\n  color: var(--primary-black2);\n}\n\n.Blog-title p{\n  font-size: 18px;\n  color: var(--primary-grey);\n}\n\n.Blog-box {\n  display: flex;\n  align-items: center;\n  width: 100%;\n  margin: 0 auto;\n  max-width: 1200px;\n  gap: 100px;\n}\n\n.Blog-left {\n  width: 50%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n}\n\n.Blog-left-round {\n  width: 500px;\n  height: 500px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-image: linear-gradient(153deg, #dbdcff, #6d72f6);\n}\n\n.Blog-left-round img {\n  width: 100%;\n  height: 580px;\n  max-width: 350px;\n  object-fit: contain;\n}\n\n.Blog-right {\n  width: 50%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n}\n\n.Blog-right-main {\n  display: flex;\n  flex-direction: column;\n}\n\n.Blog-Hidden-box {\n  padding: 20px 15px;\n  border-radius: 20px;\n  border: none;\n  background: transparent;\n  text-align: left;\n  font-size: 26px;\n  color: var(--primary-grey);\n  font-weight: bolder;\n  overflow: hidden;\n  height: 70px;\n  display: flex;\n  flex-direction: column;\n  transition: all 0.3s ease;\n  cursor: pointer;\n}\n\n.Blog-Hidden-box p {\n  font-size: 18px;\n  font-weight: 400;\n  line-height: 30px;\n  opacity: 0;\n  max-height: 0;\n  transition: all 0.3s ease;\n}\n\n.Blog-Hidden-box.active {\n  height: 120px;\n  box-shadow: 0 18px 30px 0 #dfdfdf;\n}\n\n.Blog-Hidden-box.active p {\n  opacity: 1;\n  max-height: 100px;\n}\n\n/* Responsive Styles */\n@media (max-width: 1024px) {\n  .Blog {\n    height: auto;\n    padding: 20px;\n  }\n\n  .Blog-box {\n    flex-direction: column-reverse;\n    gap: 40px;\n  }\n\n  .Blog-left,\n  .Blog-right {\n    width: 100%;\n  }\n\n  .Blog-left-round {\n    width: 80%;\n    height: auto;\n    max-width: 350px;\n  }\n\n  .Blog-left-round img {\n    height: auto;\n    max-width: 100%;\n  }\n\n  .Blog-Hidden-box {\n    font-size: 30px;\n    padding: 20px;\n  }\n\n  .Blog-Hidden-box p {\n    font-size: 16px;\n  }\n}\n\n@media (max-width: 768px) {\n  .Blog-box {\n    gap: 20px;\n  }\n\n  .Blog-Hidden-box.active {\n    height: 80px;\n  }\n\n  .Blog-left-round {\n    width: 90%;\n    max-width: 300px;\n  }\n\n  .Blog-Hidden-box {\n    font-size: 24px;\n    padding: 15px;\n  }\n\n  .Blog-Hidden-box p {\n    font-size: 14px;\n    line-height: 22px;\n  }\n}\n\n@media (max-width: 480px) {\n  .Blog-left-round {\n    width: 100%;\n    max-width: 250px;\n  }\n\n  .Blog-Hidden-box {\n    font-size: 20px;\n    padding: 10px;\n  }\n\n  .Blog-Hidden-box.active {\n    height: 100px;\n  }\n\n  .Blog-Hidden-box p {\n    font-size: 12px;\n    line-height: 18px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
